@if (!isImageCaptured()) {
  <app-image-capture-step />
} @else {
  <app-image-review-step />
}
